import React, { useEffect } from 'react';

import EventResource from 'resources/admin/EventResource';

import TabPanels from 'components/TabPanels';
import Layout from 'components/layouts/index';
import DataSelectionTable from 'components/DataTable/DataSelectionTable';

import Stats from './Stats';

import EventsFilter from './EventsFilter';

import { eventsColumns } from 'utils/tables/columns/admin/eventsColumns';
import usePaginationAndFilteringController from 'utils/usePaginationAndFilteringController';
import downloadCSV from 'utils/downloadCSV';
import moment from 'moment';

const pageInfo = {
  label: "Admin",
  name: "Events",
};

const AdminEvents = () => {

  const {
    objectState,
    fetchData,
    handlePageChange,
    handleFilterChange
  } = usePaginationAndFilteringController({
      fetchDataResource: EventResource,
      fetchDataParams: {},
  });

  const defaultStartDate = moment().startOf('day');
  const defaultEndDate = moment().endOf('week');

  useEffect(() => {
    fetchData(1, {start_date: defaultStartDate, end_date: defaultEndDate});
  }, []);


  const handleDownload = async () => {
    await downloadCSV('/admin/events', objectState.filteringParams);
  };

  return (
    <Layout context='admin'
            pageInfo={ pageInfo }
            activeMenuItem='events' >

      <TabPanels labels={[ "Events" ]} >
            <div>
              <Stats events={objectState.filteredObjects} />
              <DataSelectionTable records={objectState.filteredObjects}
                                  columns={eventsColumns}
                                  onClick={handleDownload}
                                  serverPaginationProps={{
                                    paginationServer: true,
                                    paginationTotalRows: objectState.totalCount,
                                    page: objectState.page,
                                    onChangePage: handlePageChange
                                  }}
                                  filter={
                                    <EventsFilter
                                      onChange={handleFilterChange}
                                      defaultStartDate={defaultStartDate}
                                      defaultEndDate={defaultEndDate}
                                    />
                                  }
              />
            </div>
      </TabPanels>

    </Layout>
)};

export default AdminEvents;
